module.exports = __webpack_public_path__ + "static/media/46.6454d767.jpg";